import type { InputDescription } from "@smartsuite/automation-engine-api";
import { JsonStructureEditor_Type } from "@smartsuite/automation-engine-api";

export const withInstruction = (description: InputDescription): boolean =>
  description.editor?.editor.oneofKind === "jsonStructure" &&
  description.editor?.editor.jsonStructure.type ===
    JsonStructureEditor_Type.WITH_INSTRUCTION;
